<template>
  <v-data-iterator
    :items="tenants"
    :items-per-page="20"
    :sort-by="[{ key: sortBy, order: sortDesc ? 'desc' : 'asc' }]"
    :custom-key-sort="{
      name: sortByName,
      totalUsers: sortByUsers,
      nodes: sortByNodesName,
    }"
    style="width: 100%;"
    :loading="loading"
    return-object
  >
    <template v-slot:loader>
      <v-row class="tenant-list-loading-spinner">
        <v-col class="text-center">
          <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="primary"
            :aria-label="$t('console.loadingListOfTenant')"
          />
          <div class="tenant-list-loading-spinner-text">
            {{ $t('console.loadingListOfTenant') }}
          </div>
        </v-col>
      </v-row>
    </template>

    <template v-slot:header>
      <div class="d-flex tenant-list-view-row tenants-list-view-header-row">
        <div @click="setSortBy('name')" data-cy="console-tenants-sortByName">
          {{ $t('console.name') }}
          <span v-if="sortBy === 'name'">
            <v-icon size="small">
              {{ sortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}
            </v-icon>
          </span>
        </div>
        <div @click="setSortBy('totalUsers')" data-cy="console-tenants-users">
          {{ $t('console.users') }}
          <span v-if="sortBy === 'totalUsers'">
            <v-icon size="small">
              {{ sortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}
            </v-icon>
          </span>
        </div>
        <div @click="setSortBy('nodes')" data-cy="console-tenants-folder">
          {{ $t('console.folders') }}
          <span v-if="sortBy === 'nodes'">
            <v-icon size="small">
              {{ sortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}
            </v-icon>
          </span>
        </div>
        <div>
          <slot name="topAction"></slot>
        </div>
      </div>
    </template>

    <template v-slot:default="{ items }">
      <div class="mt-2 vb-tenants-list">
        <div v-for="{ raw: item } in items" :key="item.id">
          <TenantListItem
            class="list-view-item tenant-list-view-row align-center"
            :item="item"
          >
            <template v-slot:actions>
              <slot name="itemAction" :tenant="item" />
            </template>
          </TenantListItem>
        </div>
      </div>
    </template>

    <template v-slot:footer="{ pagination, options }">
      <v-data-table-footer
        :pagination="pagination"
        :options="options"
        :items-per-page-options="footerOptions['items-per-page-options']"
        :items-per-page-text="footerOptions['pagination-text']"
        style="font-size: 10px;"
      />
    </template>
  </v-data-iterator>
</template>

<script>
import TenantListItem from './TenantListItem.vue'

export default {
  emits: ["tenantUpdated"],
  name: "TenantsListView",
  components: {
    TenantListItem,
  },
  props: {
    tenants: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  data: function() {
    return {
      sortBy: 'name',
      sortDesc: false,
      showingMenu: false,

      selectedTenant: null,
    };
  },

  methods: {
    stub: function() {
      this.showingMenu = false;
    },
    setSortBy: function(sortByColumn) {
      if (this.sortBy === sortByColumn) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortDesc = true;
        this.sortBy = sortByColumn;
      }
    },
    sortByName: function (a, b) {
      if (!a) return -1;
      if (!b) return 1;
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortByUsers: function(usersTenantA, usersTenantB) {
      return usersTenantA - usersTenantB;
    },
    sortByNodesName: function(nodesTenantA, nodesTenantB) {
      return nodesTenantA[0].name.toLowerCase().localeCompare(nodesTenantB[0].name.toLowerCase());
    },
  },

  computed: {
    footerOptions: function() {
      return {
        'items-per-page-options': [20, 30, 50, 100],
        'pagination-text': this.$t('common.itemsPerPage')
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.tenants-list-view-header-row {
  font-weight: 600;
  cursor: pointer;
  height: 54px;
  border-radius: 10px;
  align-items: center;
}

:deep(.tenant-list-view-row) {
  padding-left: 8px;
  padding-right: 8px;

  & > div {
    display: flex;
    align-items: center;
    word-break: normal;
  }

  & > div:first-child {
    text-align: left;
  }

  & > div:last-child {
    text-align: right;
  }

  /* Normal screens */
  & > div:nth-child(1) { width: 30%; word-wrap: break-word; display: inline-block; }  /* names */
  & > div:nth-child(2) { width: 20%; }  /* users */
  & > div:nth-child(3) { width: 20%; }  /* folder */
  & > div:nth-child(4) { width: 30%; justify-content: end; flex-shrink: 0; min-width: 220px; } /* actions */

  /* Small screens */
  @media only screen and (max-width: 960px) {
    & > div:nth-child(1) { width: 40%; min-width: 0; flex-shrink: 1; }      /* names */
    & > div:nth-child(2) { width: 15%; }      /* users */
    & > div:nth-child(3) { width: 15%; }      /* folder */
    & > div:nth-child(4) { width: 30%; min-width: 170px; flex-shrink: 0; }  /* actions */
  }
}

.tenant-list-loading-spinner {
  padding-top: 24px;
}
</style>
